import service from './axios';
export const getTeamMembers = (params = {}) => service.get('/manage/team-members', { params });
export const getTeamMember = (id) => service.get(`/manage/team-members/${id}`);
export const createTeamMember = (d) => service.post('/manage/team-members', d);
export const updateTeamMember = (id, d) => service.put(`/manage/team-members/${id}`, d);
export const deleteTeamMember = (id) => service.delete(`/manage/team-members/${id}`);
